/* Downloads im Pressebereich.

   Es gibt zwei Wege, Material bereitzustellen:

   1. Ablageordner src/assets/presse/ – einfach Dateien hineinlegen.
      Sie erscheinen nach dem naechsten Build automatisch im Pressebereich,
      ohne dass hier etwas geaendert werden muss. Unterordner werden zu
      eigenen Abschnitten, der Dateiname wird zur Beschriftung.

   2. Die festen Listen unten – fuer Material, das an einer bestimmten
      Stelle stehen soll: Datei importieren und im passenden Abschnitt
      eintragen. */

// Bilder – Haus, Kueche & Genuss
import landingBg from '../../assets/images/landing_bg.jpg';
import kaffee from '../../assets/images/Kaffee.jpg';
import kellnerin from '../../assets/images/Kellnerin.jpg';
import weinkeller from '../../assets/images/Weinkeller.jpg';
import weinflaschen from '../../assets/images/Weinflaschen.png';
import lamm from '../../assets/images/Lamm.jpg';
import salatCatering from '../../assets/images/Salad_Catering.jpg';
import macarons from '../../assets/images/macarons.jpg';
import toertchen from '../../assets/images/toertchen.jpg';
import greenPatti from '../../assets/images/green_patti.jpg';
import kunstRocaille from '../../assets/images/kunst_rocaille.jpg';
import gruendung from '../../assets/images/gruendung_main.jpeg';
import falstaffWelcome from '../../assets/images/fallstaff_welcome.png';

// Bilder – Team
import alexAbschluss from '../../assets/images/alex_abschluss.png.jpeg';
import alexEagle from '../../assets/images/alex_eagle.jpg';
import alexTour from '../../assets/images/alex_tour.jpg';
import michaelAnbau from '../../assets/images/michael_anbau.png';
import michaelFahrrad from '../../assets/images/michael_fahrrad.jpeg';
import michaelWein from '../../assets/images/michael_wein.png';

// Bilder – Signature Cakes
import cakeDagobert from '../../assets/images/siganture_cackes/Dagobert.png';
import cakeHerbst from '../../assets/images/siganture_cackes/Herbst.png';
import cakeMeister from '../../assets/images/siganture_cackes/Meister.png';
import cakeTurm from '../../assets/images/siganture_cackes/Turm.png';
import cakeTurm2 from '../../assets/images/siganture_cackes/Turm2.png';
import cakeDragon from '../../assets/images/siganture_cackes/dragon.png';
import cakeKingkong from '../../assets/images/siganture_cackes/kingkong.png';
import cakeKreator from '../../assets/images/siganture_cackes/kreator.png';
import cakeMonGuerlain from '../../assets/images/siganture_cackes/mon_guerlain.png';

// Auszeichnungen
import falstaffBarguide2027 from '../../assets/auszeichnungen/Falstaff_2027_Barguide.jpeg';
import falstaffBarguide from '../../assets/auszeichnungen/Falstaff_2026_Barguide.png';
import falstaffBistro from '../../assets/auszeichnungen/Falstaff_2026_BistrodesJahres.png';
import starwinelist2023 from '../../assets/auszeichnungen/Starwinelist_2023.png';
import starwinelist2025 from '../../assets/auszeichnungen/Starwinelist_2025.png';
import ihkAusland from '../../assets/auszeichnungen/ihk_ausland.png';
import kammersiegerin from '../../assets/auszeichnungen/Urkunde_Kammersiegerin.jpeg';
import ehrenurkunde from '../../assets/auszeichnungen/Ehrenurkunde.jpeg';
import gaultMillau24 from '../../assets/auszeichnungen/Gault_Millau_24.jpg';
import gaultMillau20 from '../../assets/auszeichnungen/Gault_Millau_20.jpg';
import feinschmecker23 from '../../assets/auszeichnungen/Feinschmecker_23.jpg';

// Dokumente
import ueberUnsPdf from '../../assets/pdfs/UeberUns.pdf';
import falstaffPdf from '../../assets/pdfs/Falstaff WineBarGuide.pdf';
import sommelierPdf from '../../assets/pdfs/Sommelier Magazin.pdf';
import patisseriePdf from '../../assets/pdfs/Patisserie-Anzeige.pdf';
import monGuerlainPdf from '../../assets/pdfs/Mon_guerlan.pdf';
import cateringPdf from '../../assets/pdfs/Presentation_Catering.pdf';
import streetfoodPdf from '../../assets/pdfs/Streetfood Sunday.pdf';

/* ---------- Ablageordner src/assets/presse/ ----------
   require.context liest den Ordner beim Build aus. Neue Dateien werden
   also mit dem naechsten `npm run build` uebernommen. */

const DROP_IMAGES = require.context(
  '../../assets/presse',
  true,
  /\.(jpe?g|png|gif|webp|avif|svg)$/i
);

const DROP_DOCUMENTS = require.context(
  '../../assets/presse',
  true,
  /\.pdf$/i
);

// 'Weinkeller_Detail_02.jpg' -> 'Weinkeller Detail 02'
function titleFromFilename(filename) {
  return filename
    .replace(/\.[^.]+$/, '')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function parseKey(key) {
  const parts = key.replace(/^\.\//, '').split('/');
  const filename = parts.pop();
  return { filename, folder: parts.join(' / ') };
}

/* Bilder aus dem Ablageordner, gruppiert nach Unterordner.
   Dateien, die direkt im Ordner liegen, landen unter 'Weiteres Bildmaterial'. */
function buildDropSections(context) {
  const groups = new Map();

  context.keys().sort((a, b) => a.localeCompare(b, 'de')).forEach((key) => {
    const { filename, folder } = parseKey(key);
    const title = folder || 'Weiteres Bildmaterial';
    if (!groups.has(title)) groups.set(title, []);
    groups.get(title).push({
      id: key,
      src: context(key),
      title: titleFromFilename(filename),
      file: filename,
    });
  });

  return Array.from(groups, ([title, items]) => ({
    id: `ablage-${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`,
    title,
    items,
  }));
}

function buildDropDocuments(context) {
  return context.keys()
    .sort((a, b) => a.localeCompare(b, 'de'))
    .map((key) => {
      const { filename } = parseKey(key);
      return {
        id: key,
        src: context(key),
        title: titleFromFilename(filename),
        file: filename,
      };
    });
}

const dropSections = buildDropSections(DROP_IMAGES);
const dropDocuments = buildDropDocuments(DROP_DOCUMENTS);

const fixedSections = [
  {
    id: 'haus',
    title: 'Haus, Küche & Genuss',
    items: [
      { src: landingBg,      title: 'Rocaille – Ansicht',        file: 'Rocaille_Ansicht.jpg' },
      { src: kaffee,         title: 'Kaffee',                    file: 'Rocaille_Kaffee.jpg' },
      { src: kellnerin,      title: 'Service',                   file: 'Rocaille_Service.jpg' },
      { src: weinkeller,     title: 'Weinkeller',                file: 'Rocaille_Weinkeller.jpg' },
      { src: weinflaschen,   title: 'Weinauswahl',               file: 'Rocaille_Weinauswahl.png' },
      { src: lamm,           title: 'Lamm',                      file: 'Rocaille_Lamm.jpg' },
      { src: salatCatering,  title: 'Catering',                  file: 'Rocaille_Catering.jpg' },
      { src: macarons,       title: 'Macarons',                  file: 'Rocaille_Macarons.jpg' },
      { src: toertchen,      title: 'Törtchen',                  file: 'Rocaille_Toertchen.jpg' },
      { src: greenPatti,     title: 'Pâtisserie',                file: 'Rocaille_Patisserie.jpg' },
      { src: kunstRocaille,  title: 'Kunst im Rocaille',         file: 'Rocaille_Kunst.jpg' },
      { src: gruendung,      title: 'Gründung',                  file: 'Rocaille_Gruendung.jpeg' },
      { src: falstaffWelcome, title: 'Falstaff Welcome',         file: 'Rocaille_Falstaff_Welcome.png' },
    ],
  },
  {
    id: 'team',
    title: 'Team',
    items: [
      { src: alexAbschluss,   title: 'Alexandra Wende – Abschluss', file: 'Rocaille_Alexandra_Wende_Abschluss.jpeg' },
      { src: alexEagle,       title: 'Alexandra Wende',             file: 'Rocaille_Alexandra_Wende.jpg' },
      { src: alexTour,        title: 'Alexandra Wende – Tour',      file: 'Rocaille_Alexandra_Wende_Tour.jpg' },
      { src: michaelWein,     title: 'Michael B. Spreckelmeyer',    file: 'Rocaille_Michael_Spreckelmeyer.png' },
      { src: michaelAnbau,    title: 'Michael B. Spreckelmeyer – Anbau',   file: 'Rocaille_Michael_Spreckelmeyer_Anbau.png' },
      { src: michaelFahrrad,  title: 'Michael B. Spreckelmeyer – Fahrrad', file: 'Rocaille_Michael_Spreckelmeyer_Fahrrad.jpeg' },
    ],
  },
  {
    id: 'cakes',
    title: 'Signature Cakes',
    items: [
      { src: cakeDagobert,    title: 'Dagobert',     file: 'Rocaille_Cake_Dagobert.png' },
      { src: cakeHerbst,      title: 'Herbst',       file: 'Rocaille_Cake_Herbst.png' },
      { src: cakeMeister,     title: 'Meister',      file: 'Rocaille_Cake_Meister.png' },
      { src: cakeTurm,        title: 'Turm',         file: 'Rocaille_Cake_Turm.png' },
      { src: cakeTurm2,       title: 'Turm II',      file: 'Rocaille_Cake_Turm_II.png' },
      { src: cakeDragon,      title: 'Dragon',       file: 'Rocaille_Cake_Dragon.png' },
      { src: cakeKingkong,    title: 'King Kong',    file: 'Rocaille_Cake_KingKong.png' },
      { src: cakeKreator,     title: 'Kreator',      file: 'Rocaille_Cake_Kreator.png' },
      { src: cakeMonGuerlain, title: 'Mon Guerlain', file: 'Rocaille_Cake_MonGuerlain.png' },
    ],
  },
  {
    id: 'auszeichnungen',
    title: 'Auszeichnungen',
    items: [
      { src: falstaffBarguide2027, title: 'Falstaff Bar Guide 2027 – 95 Punkte', file: 'Rocaille_Falstaff_BarGuide_2027.jpeg' },
      { src: falstaffBarguide, title: 'Falstaff Bar Guide 2026',            file: 'Rocaille_Falstaff_BarGuide_2026.png' },
      { src: falstaffBistro,   title: 'Falstaff Bistro des Jahres 2026',    file: 'Rocaille_Falstaff_BistroDesJahres_2026.png' },
      { src: starwinelist2025, title: 'Star Wine List 2025',                file: 'Rocaille_StarWineList_2025.png' },
      { src: starwinelist2023, title: 'Star Wine List 2023',                file: 'Rocaille_StarWineList_2023.png' },
      { src: gaultMillau24,    title: 'Gault&Millau – Best International Wine List 2023/24', file: 'Rocaille_GaultMillau_2024.jpg' },
      { src: gaultMillau20,    title: 'Gault&Millau 2020 – 14 Punkte',      file: 'Rocaille_GaultMillau_2020.jpg' },
      { src: feinschmecker23,  title: 'Der Feinschmecker 2023',             file: 'Rocaille_Feinschmecker_2023.jpg' },
      { src: ihkAusland,       title: 'IHK Auszeichnung',                   file: 'Rocaille_IHK.png' },
      { src: kammersiegerin,   title: 'Kammersiegerin 2023',                file: 'Rocaille_Kammersiegerin_2023.jpeg' },
      { src: ehrenurkunde,     title: 'Ehrenurkunde Meisterprüfung',        file: 'Rocaille_Ehrenurkunde.jpeg' },
    ],
  },
];

export const imageSections = [...fixedSections, ...dropSections];

const fixedDocuments = [
  { src: ueberUnsPdf,     title: 'Über uns',                file: 'Rocaille_Ueber_uns.pdf' },
  { src: falstaffPdf,     title: 'Falstaff Wine Bar Guide', file: 'Rocaille_Falstaff_WineBarGuide.pdf' },
  { src: sommelierPdf,    title: 'Sommelier Magazin',       file: 'Rocaille_Sommelier_Magazin.pdf' },
  { src: patisseriePdf,   title: 'Pâtisserie-Anzeige',      file: 'Rocaille_Patisserie_Anzeige.pdf' },
  { src: monGuerlainPdf,  title: 'Mon Guerlain',            file: 'Rocaille_Mon_Guerlain.pdf' },
  { src: cateringPdf,     title: 'Catering Präsentation',   file: 'Rocaille_Catering_Praesentation.pdf' },
  { src: streetfoodPdf,   title: 'Streetfood Sunday',       file: 'Rocaille_Streetfood_Sunday.pdf' },
];

export const documents = [...fixedDocuments, ...dropDocuments];
